// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { RootState } from "..";
// import { notificationsProps } from "../../interfaces";

// const initialState: any = [] as any;

// export const websiteQueryQueuesSlice = createSlice({
//   name: "websiteQueryQueues",
//   initialState,
//   reducers: {
//     setWebsiteQueryQueues: (state, action: PayloadAction<any[]>) => {
//       if (action.payload.length === 0) {
//         return [];
//       }
//       const existingIds = new Set(state.map((item) => item.id));
//       const newItems = action?.payload?.filter(
//         (item) => !existingIds?.has(item.id)
//       );

//       const updatedState = [...state, ...newItems];

//       return updatedState.sort((a, b) => {
//         const dateA = new Date(a.created_at);
//         const dateB = new Date(b.created_at);
//         return dateB.getTime() - dateA.getTime();
//       });
//     },

//     removeWebsiteQueryQueues: () => {
//       return initialState;
//     },
//     removeSingleWebsiteQueryQueue: (state, action: PayloadAction<any>) => {
//       return state.filter((item) => item.query_id !== action.payload);
//     },
//   },
// });

// export const { setWebsiteQueryQueues, removeWebsiteQueryQueues, removeSingleWebsiteQueryQueue } =
//   websiteQueryQueuesSlice.actions;

// export const selectWebsiteQueryQueues = (state: RootState) => {
//   return state.websiteQueryQueues;
// };

// export default websiteQueryQueuesSlice.reducer;


import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { queryQueueProps } from "../../interfaces";

// ─── State Shape ──────────────────────────────────────────────────────────────

export interface WebsiteQueryQueueState {
  data: queryQueueProps[];
  currentPage: number;
  lastPage: number;
  total: number;
}

const initialState: WebsiteQueryQueueState = {
  data: [],
  currentPage: 1,
  lastPage: 1,
  total: 0,
};

// ─── Payload Type ─────────────────────────────────────────────────────────────

interface QueuePagePayload {
  data: queryQueueProps[];
  currentPage: number;
  lastPage: number;
  total: number;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────


// ─── Slice ────────────────────────────────────────────────────────────────────

export const websiteQueryQueuesSlice = createSlice({
  name: "websiteQueryQueues",
  initialState,
  reducers: {
    // Page 1: full replace
    setWebsiteQueryQueues: (
      state,
      action: PayloadAction<QueuePagePayload>
    ) => {
      state.data = (action.payload.data);
      state.currentPage = action.payload.currentPage;
      state.lastPage = action.payload.lastPage;
      state.total = action.payload.total;
    },

    // Page 2+: append without duplicates
    appendWebsiteQueryQueues: (
      state,
      action: PayloadAction<QueuePagePayload>
    ) => {
      const existingIds = new Set(state.data.map((item) => item.id));
      const newItems = action.payload.data.filter(
        (item) => !existingIds.has(item.id)
      );
      state.data = ([...state.data, ...newItems]);
      state.currentPage = action.payload.currentPage;
      state.lastPage = action.payload.lastPage;
      state.total = action.payload.total;
    },

    // Remove a single item by query_id (e.g. after assigning)
    removeSingleWebsiteQueryQueue: (
      state,
      action: PayloadAction<string>
    ) => {
      state.data = state.data.filter(
        (item) => item.query_id !== action.payload
      );
      state.total = Math.max(0, state.total - 1);
    },

    // Full reset
    removeWebsiteQueryQueues: () => initialState,
  },
});

export const {
  setWebsiteQueryQueues,
  appendWebsiteQueryQueues,
  removeSingleWebsiteQueryQueue,
  removeWebsiteQueryQueues,
} = websiteQueryQueuesSlice.actions;

export const selectWebsiteQueryQueues = (state: RootState) =>
  state.websiteQueryQueues;

export const selectWebsiteQueryQueueData = (state: RootState) =>
  state.websiteQueryQueues.data;

export const selectWebsiteQueryQueueHasMore = (state: RootState) =>
  state.websiteQueryQueues.currentPage < state.websiteQueryQueues.lastPage;

export default websiteQueryQueuesSlice.reducer;